import { render, staticRenderFns } from "./updafeInfo.vue?vue&type=template&id=0620d88a&scoped=true&"
import script from "./updafeInfo.vue?vue&type=script&lang=js&"
export * from "./updafeInfo.vue?vue&type=script&lang=js&"
import style0 from "./updafeInfo.vue?vue&type=style&index=0&id=0620d88a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620d88a",
  null
  
)

export default component.exports